import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chatList: [],
  messages: [],
  activeChat: null,

  chatListLoading: false,
  messagesLoading: false,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatList(state, action) {
      console.log({ chatListDispatch: action.payload });
      state.chatList = action.payload;
      state.chatListLoading = false;
    },

    setActiveChat(state, action) {
      state.activeChat = action.payload;
      state.messages = [];
      state.messagesLoading = true;
    },

    setMessages(state, action) {
      state.messages = action.payload;
      state.messagesLoading = false;
    },

    addMessage(state, action) {
      const payload = action.payload;

      state.messages = payload;

      state.messagesLoading = false;
    },
    resetChat(state) {
      state.messages = [];
      state.activeChat = null;
    },
  },
});

export const {
  setChatList,
  setActiveChat,
  setMessages,
  addMessage,
  resetChat,
} = chatSlice.actions;

export default chatSlice.reducer;
